/** @module Enums */ /** typedoc */
var AccountGlobalStatusEnum;
(function (AccountGlobalStatusEnum) {
    /**
     * AccountingStatus == 'Good' && ServiceStatus == 'Active'
     */
    AccountGlobalStatusEnum["Active"] = "Active";
    /**
     * AccountingStatus == ('PoorStanding' | 'Collections') && ServiceStatus == 'Active'
     */
    AccountGlobalStatusEnum["PoorStanding"] = "PoorStanding";
})(AccountGlobalStatusEnum || (AccountGlobalStatusEnum = {}));

export { AccountGlobalStatusEnum };
